import { render, staticRenderFns } from "./MinisiteList.vue?vue&type=template&id=9baef1a4&"
import script from "./MinisiteList.vue?vue&type=script&lang=js&"
export * from "./MinisiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports